import { cn } from "@/lib/utils";

interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
  testId?: string;
}

export function PageHeader({ icon, title, description, actions, className, testId }: PageHeaderProps) {
  return (
    <div className={cn("flex items-center justify-between gap-4 flex-wrap", className)}>
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10 flex-shrink-0">
          {icon}
        </div>
        <div>
          <h1 className="text-2xl font-semibold" style={{ color: '#2C3E50' }} data-testid={testId || "text-page-title"}>
            {title}
          </h1>
          {description && (
            <p className="text-muted-foreground text-sm">
              {description}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
